
var CustomerReviews = function()
{


	/**
	 * [list description]
	 * @return {[type]} [description]
	 */
	this.list = function()
	{

		/**
		 * [viewHandler description]
		 * @param  {[type]} e [description]
		 * @return {[type]}   [description]
		 */
		var viewHandler = function(e)
		{
			e.preventDefault();
			$.fn.ensphere.veto.modalEdit( this );
		};

		/**
		 * [approvingHandler description]
		 * @param  {[type]} e [description]
		 * @return {[type]}   [description]
		 */
		var approvingHandler = function(e)
		{

			var checked = $(this).is(':checked');
			var url = $(this).attr( 'data-url' );
			$.get( url, { checked : checked } );
		};

		/**
		 * [bindEvents description]
		 * @return {[type]} [description]
		 */
		var bindEvents = function()
		{
            $.fn.ensphere.veto.select('[data-for="view-review"]').forEach(function(elm){
                $.fn.ensphere.veto.clickEvent( elm, viewHandler );
			});
			$('[data-for="approving"]').change( approvingHandler );

		};

		/**
		 * [description]
		 * @return {[type]} [description]
		 */
		return new function()
		{
			bindEvents();
		};
	};

};

jQuery(document).ready( function($){

	var customerReviews = new CustomerReviews();

	if( $('[data-javascript="customer-reviews"]').length ) {
		customerReviews.list();
	}

	var selectors = [
		'.customer.list .trash.icon',
		'.countries.list .trash.icon',
		'.customer-groups.list .trash.icon'
	];

	$(selectors.join()).parent().click( function(e){
		var button = $(this);
		e.preventDefault();
		swal({
	        title: "Are you sure?",
	        text: "This action cannot be reversed",
	        type: "warning",
	        showCancelButton: true,
	        confirmButtonClass: 'btn-danger',
	        confirmButtonText: 'Yes, delete it!',
	        cancelButtonText: "No, cancel please!",
	        closeOnConfirm: false,
	        closeOnCancel: false
        }, function( isConfirm ) {
	        if ( isConfirm ) {
	            window.location = button.attr('href');
	        } else {
	            swal.close();
	        }
	    });
	});

});
//# sourceMappingURL=all.js.map
